module.exports = __webpack_public_path__ + "img/facebook-pixel.0e58dfc6.png";